export default function MobileHelp() {
    return (
        <div className="apply-mobile-help">
            <span>
                Besoin d'aide pour vous inscrire ?
            </span>
            <br/>
            <span>
                Contactez-nous au <a href="tel:+33554547771">05 54 54 77 71</a>
            </span>
        </div>
    );
}